import { render, staticRenderFns } from "./ObrociTab.vue?vue&type=template&id=b8d347ae"
import script from "./ObrociTab.vue?vue&type=script&lang=js"
export * from "./ObrociTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports